import React from "react";
import styles from "./WorkflowBuilder.module.css";

const WorkflowBuilder = () => {
    return (
        <section className={styles.page}>
            <div className={styles.container}>
                <div className={styles.header}>
                    ✨ Workflow Builder
                </div>

                <div className={styles.canvas}>
                    <div className={styles.flow}>
                        <div className={`${styles.node} ${styles.start}`}>Start</div>
                        <div className={styles.line} />

                        <div className={`${styles.node} ${styles.aiCall}`}>AI Call</div>
                        <div className={styles.line} />

                        <div className={`${styles.node} ${styles.decision}`}>
                            Paid?
                            <div className={styles.decisionActions}>
                                <span className={styles.yes}>Yes ✓</span>
                                <span className={styles.no}>No ✕</span>
                            </div>
                        </div>

                        <div className={styles.branch}>
                            <div className={`${styles.node} ${styles.whatsapp}`}>WhatsApp</div>
                            <div className={`${styles.node} ${styles.loop}`}>Loop</div>
                        </div>

                        <div className={styles.line} />
                        <div className={`${styles.node} ${styles.end}`}>End</div>
                    </div>
                </div>

                <div className={styles.footer}>
                    Visual drag-and-drop builder · No coding required · Real-time preview
                </div>
            </div>
        </section>
    );
};

export default WorkflowBuilder;